/**
 * Bootstraps the Svelte SPA, registers service worker, and wires global router.
 * Pseudocode:
 * - Mount App.svelte to #app
 * - Register service worker (non-blocking)
 */
import './app.css';
import App from './App.svelte';
import { initPwaInstall } from '$lib/state/pwa';
import { initServiceWorker } from '$lib/state/sw';

// Mount root app
new App({ target: document.getElementById('app')! }); // !: element exists in index.html

// Register service worker (best-effort; ignore failures)
if ('serviceWorker' in navigator) {
  // Non-blocking SW registration to support offline shell
  navigator.serviceWorker.register('/sw.js').then(() => initServiceWorker()).catch(() => {});
}

initPwaInstall();
